import React, { useState } from "react";
import {
    Grid,
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Button,
} from "@material-ui/core";

import { makeStyles, withStyles } from '@material-ui/core/styles';

import C1InputField from "app/c1component/C1InputField";
import C1DateField from "app/c1component/C1DateField";
import C1HeaderTitle from "app/c1component/C1HeaderTitle";
import C1PopUp from "app/c1component/C1PopUp";
import VisibilityIcon from '@material-ui/icons/Visibility';

import { useStyles } from "app/c1utils/styles";
import useAuth from "app/hooks/useAuth";
import moment from "moment";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#3C77D0',
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useTableStyle = makeStyles({
    table: {
        minWidth: 450,
        tableLayout: "auto",
    },
    column: {
        width: 50,
    },
});

const RaeoAppRegulatoryAgency = ({
    inputData,
    handleInputChange,
    handleDateChange,
    handleInputChangeDeep,
    errors,
    isDisabled,
    isFeedbackOfficer,
    isSubmitting }) => {

    const [refreshPage, setRefreshPage] = useState(0);

    const tableCls = useTableStyle();

    const agencyReports = inputData?.TSctRaeoAppReg?.TSctRaeoAppRegAgencyReports || [];

    const classes = useStyles();
    const { user } = useAuth();

    const disable = agencyReports.some((report) => report.regAgencyRptUidCreate === user.id);

    const handleInputChangeDeepWrap = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        handleInputChangeDeep(name, value);
        setRefreshPage(refreshPage + 1);
    }

    if (!isDisabled && !(inputData?.TSctRaeoAppReg?.regAgency)) {
        // default agent name.
        //inputData.aeoAgencyName = user.coreAccn?.accnName;
        //handleInputChangeDeep("TSctRaeoAppReg.TCoreAccn.accnId", user.coreAccn?.accnId); 
        //handleInputChangeDeep("TSctRaeoAppReg.TCoreAccn.accnName", user.coreAccn?.accnName); 
        //handleInputChangeDeep("TSctRaeoAppReg.regAgency", user.coreAccn?.accnName); 
    }

    const defaultUserName = (!isDisabled) ? user.name : "";

    const [openPopUp, setOpenPopUp] = useState(false);
    const [selectedRow, setSelectedRow] = useState("");

    const handlePopUpReplyWindow = (id) => {
        setSelectedRow(agencyReports[id]);
        setOpenPopUp(true);
    }
    
    return (
        isFeedbackOfficer ? (
            <React.Fragment>
                <C1HeaderTitle>Regulatory Agency Report List</C1HeaderTitle>
                <Box className="m-3 pt-3">
                <TableContainer component={Paper}>
                    <Table className={tableCls.table} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center">No.</StyledTableCell>
                                <StyledTableCell align="center">Regulatory Agency</StyledTableCell>
                                <StyledTableCell align="center">Report</StyledTableCell>
                                <StyledTableCell align="center">User</StyledTableCell>
                                <StyledTableCell align="center">Date</StyledTableCell>
                                <StyledTableCell align="center">Action</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {agencyReports.map((report, index) => (
                                <TableRow key={index}>
                                    <StyledTableCell align="center">{index + 1}</StyledTableCell>
                                    <StyledTableCell align="center">{report.regAgency}</StyledTableCell>
                                    <StyledTableCell align="center">
                                        {report.regAgencyRpt.length > 10
                                            ? report.regAgencyRpt.substring(0, 10) + '...'
                                                                               : report.regAgencyRpt}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">{report.regAgencyRptUidCreate}</StyledTableCell>
                                    <StyledTableCell align="center">{moment(report.regAgencyRptDtCreate).format('DD/MM/YYYY hh:mm:ss')}</StyledTableCell>
                                    <StyledTableCell align="center"><IconButton aria-label="Preview" type="button"
                                            color="primary" onClick={() => handlePopUpReplyWindow(index)}>
                                            <VisibilityIcon />
                                        </IconButton>
                                    </StyledTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <C1PopUp
                title="Report"
                openPopUp={openPopUp}
                setOpenPopUp={setOpenPopUp}>
                <Grid container spacing={1} alignItems="center" >
                    <Grid item xs={12}>
                        <C1InputField
                            label="Report"
                            name="userFeedback"
                            multiline
                            rows={10}
                            value={selectedRow.regAgencyRpt || ''}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={9}>
                    </Grid>
                    <Grid item xs={3}>
                        {(false) && <Button variant="contained"
                            color="secondary"
                            size="large"
                            fullWidth
                            onClick={(e) => setOpenPopUp(false)}>Close</Button>}
                    </Grid>
                </Grid>
            </C1PopUp>
            </React.Fragment>
        ) : (
            <React.Fragment>
                <C1HeaderTitle>Header Information</C1HeaderTitle>
                <Grid container alignItems="center" spacing={3} className={classes.gridContainer}>
                    <Grid item lg={6} md={6} xs={12}>
                        <C1DateField
                            label="Regulated Date"
                            name="aeoReviewedDate"
                            value={inputData?.TSctRaeoAppReg?.regDtLupd || ""}
                            required
                            disabled
                        />
                    </Grid>
                    <Grid item lg={6} md={6} xs={12}>
                        <C1InputField
                            label="Regulated By"
                            name="usrName"
                            value={inputData?.TSctRaeoAppReg?.TCoreUsr?.usrName || defaultUserName}
                            required
                            disabled
                        />
                    </Grid>
                </Grid>
                <C1HeaderTitle>Details</C1HeaderTitle>
                <Grid container alignItems="center" spacing={3} className={classes.gridContainer}>
                    <Grid item xs={12}>
                        <C1InputField
                            label="Agency Name"
                            name="TSctRaeoAppReg.regAgency"
                            required
                            value={user.coreAccn?.accnName || ""}
                            disabled
                        />
                        <C1InputField
                            multiline
                            label="Report Summary"
                            name="TSctRaeoAppReg.regRptSummary"
                            rows={5}
                            required
                            disabled={isDisabled || disable}
                            inputProps={{ 'maxLength': 1024 }}
                            value={inputData?.TSctRaeoAppReg?.regRptSummary || ""}
                            onChange={handleInputChangeDeepWrap}
                            error={errors['TSctRaeoAppReg.regRptSummary'] !== undefined}
                            helperText={errors['TSctRaeoAppReg.regRptSummary'] || ''}
                        />
                    </Grid>
                </Grid>
                <Box width={1}>&nbsp;</Box>
            </React.Fragment>
        )
    );
    
};

export default RaeoAppRegulatoryAgency;